import { Injectable } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { COLORS } from '../shared/constants';
import { MatDialog } from '@angular/material/dialog';
import { AppConfirmDialogComponent } from '../shared/components/confirm-dialog/confirm-dialog.component';
import { IConfirmDialog } from '../interfaces/IDialog';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
    private toast: HotToastService) { }

  success(message: string, duration: number = 3000) {
    this.toast.success(message, {
      position: 'top-right',
      duration: duration,
      style: {
        padding: '16px',
        borderLeft: `5px solid ${COLORS.PRIMARY}`,
      },
      iconTheme: {
        primary: `${COLORS.PRIMARY}`,
      }
    });
  }

  error(message: string, duration: number = 3000) {
    this.toast.error(message, {
      position: 'top-right',
      duration: duration,
      style: {
        padding: '16px',
        borderLeft: `5px solid ${COLORS.DANGER}`
      }
    });
  }

  warning(message: string) {
    this.toast.warning(message, {
      position: 'top-right',
      duration: 3000,
      style: {
        padding: '16px',
        borderLeft: `5px solid ${COLORS.WARNING}`
      }
    });
  }

  info(message: string) {
    this.toast.info(message, {
      position: 'top-right',
      duration: 3000,
      style: {
        padding: '16px',
        borderLeft: `5px solid ${COLORS.PRIMARY}`
      }
    });
  }

  confirm(config: IConfirmDialog) {
    const dialogRef = this.dialog.open(AppConfirmDialogComponent, { data: config });
    dialogRef.afterClosed().subscribe((confirm) => {
      confirm ? config.onConfirm() : config.onCancel?.();
    });
  }
}
